export default [
    { value: '1', en: 'By mail to your correspondence address', zh_CN: '邮寄至您的通信地址', zh_HK: '郵寄至您的通訊地址' },
    { value: '2', en: "You'll collect it from the branch", zh_CN: '在分行领取', zh_HK: '於分行領取' }
]